import {cx} from "@emotion/css";
import {ReactComponent as SvgArrowRightLeft} from "assets/svg/arrow-right-left.svg";

import {designColors} from "~/ui";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmArrowRightLeftIcon: React.FC<IIconBase> = ({id, size = "lg", color = designColors.black, className}) => {
  return <SvgArrowRightLeft id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
